import { render, staticRenderFns } from "./tiktokScreenShot.vue?vue&type=template&id=492f7bca"
import script from "./tiktokScreenShot.vue?vue&type=script&lang=js"
export * from "./tiktokScreenShot.vue?vue&type=script&lang=js"
import style0 from "./tiktokScreenShot.vue?vue&type=style&index=0&id=492f7bca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports